/**
 * Shared role constants — single source of truth for RBAC.
 * Maps to the `app_role` enum in the database.
 */
export const ROLES = {
  ADMIN: 'admin',
  LANDLORD: 'landlord',
  TENANT: 'tenant',
} as const;

export type AppRole = (typeof ROLES)[keyof typeof ROLES];

/** Vietnamese labels for roles */
export const ROLE_LABELS: Record<AppRole, string> = {
  [ROLES.ADMIN]: 'Quản trị viên',
  [ROLES.LANDLORD]: 'Chủ nhà',
  [ROLES.TENANT]: 'Người thuê',
};

/** Role-based dashboard redirect paths */
export const ROLE_DASHBOARDS: Record<AppRole, string> = {
  [ROLES.ADMIN]: '/admin',
  [ROLES.LANDLORD]: '/landlord',
  [ROLES.TENANT]: '/tenant',
};

/** Default role for new / unknown users */
export const DEFAULT_ROLE: AppRole = ROLES.TENANT;

/** Property status Vietnamese labels */
export const PROPERTY_STATUS_LABELS: Record<string, string> = {
  available: 'Còn trống',
  rented: 'Đã cho thuê',
  maintenance: 'Đang bảo trì',
  inactive: 'Ngưng hoạt động',
};

/** Booking status Vietnamese labels */
export const BOOKING_STATUS_LABELS: Record<string, string> = {
  pending: 'Chờ duyệt',
  approved: 'Đã duyệt',
  rejected: 'Từ chối',
  cancelled: 'Đã hủy',
  completed: 'Hoàn thành',
};

/** Payment status Vietnamese labels */
export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  pending: 'Chờ xử lý',
  processing: 'Đang xử lý',
  completed: 'Hoàn thành',
  failed: 'Thất bại',
  refunded: 'Đã hoàn tiền',
};
